var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.3466eae1c726045a61553cf34152c1fd.svg#f';
                    var viewUrl = 'sprites.3466eae1c726045a61553cf34152c1fd.svg#view-f';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };